export const AuthLegalLinks = () => {
  return (
    <div className="mt-7 border-t border-brand-grayscale-4 pt-4">
      <nav className="flex flex-nowrap items-center justify-center gap-x-2 whitespace-nowrap text-xs text-muted-foreground">
        <a
          href="/documents/terms-of-use.pdf"
          target="_blank"
          rel="noreferrer"
          className="underline-offset-2 transition-colors hover:text-foreground hover:underline"
        >
          Termos e Condições
        </a>
        <span aria-hidden className="text-brand-grayscale-5">
          ·
        </span>
        <a
          href="/documents/privacy-policy.pdf"
          target="_blank"
          rel="noreferrer"
          className="underline-offset-2 transition-colors hover:text-foreground hover:underline"
        >
          Política de Privacidade
        </a>
      </nav>
    </div>
  )
}
